import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Swal from "sweetalert2";
import axiosInstance from "../../config/axiosConfig";
import Actions from "../../components/courses/Actions";
import { CircularProgress } from "@mui/material";

const customModalStyles = {
    content: {
        padding: "20px",
        width: "80%",
        maxWidth: "600px",
        margin: "auto",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    },
};
export default function Research() {
    const [researches, setResearches] = useState([]);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editResearchId, seteditResearchId] = useState(null);
    const [sortByLatest, setSortByLatest] = useState(false);
    const [formData, setformData] = useState({
        file: "",
        title: "",
        description: "",
        type: "",
        category: "",
        tag: ""
    });
    const [ResearchFetchLoading, setResearchFetchLoading] = useState(false);
    const [buttonLoading, setbuttonLoading] = useState(false);
    const [imgFile, setImgFile] = useState(null);
    const [imgPreview, setImgPreview] = useState(null);
    useEffect(() => {
        // Set image preview when formData.img changes (for edit case)
        if (formData.file) {
            setImgPreview(formData.file);
        }
    }, [formData.file]);

    useEffect(() => {
        // Fetch researches on component mount
        fetchResearches();
    }, []);

    // Fetch all researches
    const fetchResearches = async () => {
        setResearchFetchLoading(true);
        try {
            const response = await axiosInstance.get("research/all");
            setResearches(response.data.data);
        } catch (error) {
            console.error("Error fetching researches:", error);
        }
        setResearchFetchLoading(false);
    };

    // Handle create research
    const handleCreateResearch = async (e) => {
        e.preventDefault();
        setbuttonLoading(true);
        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
            if (key === "file") {
                return;
            }
            formDataToSend.append(key, formData[key]);
        });
        if (imgFile) {
            formDataToSend.append("file", imgFile);
        }
        try {
            await axiosInstance.post("research/create", formDataToSend);
            fetchResearches();
            setShowCreateModal(false);
            setImgFile(null);
            setImgPreview(null);
            Swal.fire("Success!", "Research created successfully!", "success", 1500);
            setformData({
                file: "",
                title: "",
                description: "",
                type: "",
                category: "",
                tag: ""
            });
        } catch (error) {
            console.error("Error creating research:", error);
            Swal.fire("Error", "Failed to create research", "error");
        }
        setbuttonLoading(false);
    };

    // Handle edit research
    const handleEditResearch = async (e) => {
        e.preventDefault();
        setbuttonLoading(true);
        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
            if (key === "file") {
                return;
            }
            formDataToSend.append(key, formData[key]);
        });

        if (imgFile) {
            formDataToSend.append("file", imgFile);
        }
        formDataToSend.append("_method", "PUT");
        try {
            await axiosInstance.post(`research/change/${editResearchId}`, formDataToSend);
            fetchResearches();
            setShowEditModal(false);
            setImgFile(null);
            Swal.fire("Success!", "Research updated successfully!", "success");
        } catch (error) {
            console.error("Error updating research:", error);
            const message = error.response?.data?.message || "Failed to update research";
            Swal.fire("Error", message, "error");
        }
        setbuttonLoading(false);
    };
    const handleViewResearch = async (id) => {
        setShowEditModal(true);

        try {
            setShowEditModal(true);
            seteditResearchId(id);
            const response = await axiosInstance.get(`research/single/${id}`);
            const data = response?.data?.data;

            setformData({
                description: data.description || "",
                title: data.title || "",
                type: data.type || "",
                category: data.category || "",
                tag: data.tag || "",
                file: data.img || "",

            });
        } catch (error) {
            console.error("Error updating research:", error);
            Swal.fire("Error", "Failed to update research", "error");
        }
    };
    // Handle delete research
    const handleDeleteResearch = async (id) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, delete it!",
            });
            if (result.isConfirmed) {
                await axiosInstance.delete(`research/delete/${id}`);
                fetchResearches();
                Swal.fire("Deleted!", "Research deleted successfully", "success", 1500);
            }
        } catch (error) {
            console.error("Error deleting research:", error);
            Swal.fire("Error", "Failed to delete research", "error");
        }
    };
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setformData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
        }));
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImgFile(file);
            setImgPreview(URL.createObjectURL(file));
        }
    };
    const sortedResearches = sortByLatest
        ? [...researches].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        : researches || [];
    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button
                    onClick={() => setShowCreateModal(true)}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#4CAF50",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        marginBottom: "20px",
                        cursor: "pointer",
                    }}
                >
                    Create New Research
                </button>
                <button
                    onClick={() => setSortByLatest((prev) => !prev)}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: sortByLatest ? "#2196F3" : "#f0f0f0",
                        color: sortByLatest ? "#fff" : "#000",
                        border: "none",
                        borderRadius: "5px",
                        marginBottom: "20px",
                        cursor: "pointer",
                        marginRight: "150px",
                    }}
                >
                    {sortByLatest ? "Show Default" : "Show Latest"}
                </button>
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                {ResearchFetchLoading ? (
                    <div
                        style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 9999,
                        }}
                    >
                        {" "}
                        <CircularProgress />{" "}
                    </div>
                ) : (
                    sortedResearches.map((research) => (
                        <div
                            key={research._id}
                            style={{
                                width: "250px",
                                padding: "15px",
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                textAlign: "center",
                            }}
                        >
                            <img
                                src={research.img || "/uo-16-9.webp"}
                                alt={research.title}
                                style={{
                                    width: "100%",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                    marginBottom: "15px",
                                    aspectRatio: "16/9",
                                }}
                            />
                            <h3>{research.title}</h3>
                            <p>{research.description}</p>
                            <Actions
                                courseId={research._id}
                                onEdit={handleViewResearch}
                                onDelete={handleDeleteResearch}
                            />
                        </div>
                    ))
                )}
            </div>

            <Modal
                isOpen={showCreateModal}
                onRequestClose={() => setShowCreateModal(false)}
                style={customModalStyles}
                contentLabel="Create New Research"
            >
                <h2>Create New Research</h2>
                <form onSubmit={handleCreateResearch}>
                    {[
                        { label: "Title", name: "title", type: "text", required: true },
                        { label: "Description", name: "description", type: "textarea" },
                        { label: "Type", name: "type", type: "text" },
                        { label: "Category", name: "category", type: "text" },
                        { label: "Tag", name: "tag", type: "text" },
                    ].map(({ label, name, type, required }) => (
                        <div key={name} style={{ marginBottom: "10px" }}>
                            <label
                                style={{
                                    display: "block",
                                    fontWeight: "bold",
                                    marginBottom: "5px",
                                }}
                            >
                                {label}
                            </label>
                            {type === "textarea" ? (
                                <textarea
                                    name={name}
                                    value={formData[name]}
                                    onChange={handleChange}
                                    required={required}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        height: "100px",
                                    }}
                                />
                            ) : (
                                <input
                                    type={type}
                                    name={name}
                                    value={formData[name]}
                                    onChange={handleChange}
                                    required={required}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            )}
                        </div>
                    ))}
                    <div style={{ marginBottom: "10px" }}>
                        <label
                            style={{
                                display: "block",
                                fontWeight: "bold",
                                marginBottom: "5px",
                            }}
                        >
                            Upload
                        </label>
                        <input
                            type="file"
                            onChange={handleFileChange}
                            required
                            style={{
                                width: "100%",
                                padding: "8px",
                                fontSize: "14px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                            }}
                        />
                    </div>

                    {imgPreview && (
                        <img
                            src={imgPreview}
                            alt="Preview"
                            style={{ width: "30%", height: "auto", marginBottom: "15px" }}
                        />
                    )}
                    <button
                        type="submit"
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "#4CAF50",
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            marginTop: "10px",
                        }}
                    >
                        {buttonLoading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            "Create"
                        )}
                    </button>
                </form>
            </Modal>

            <Modal
                isOpen={showEditModal}
                onRequestClose={() => {
                    setformData({
                        file: "",
                        title: "",
                        description: "",
                        type: "",
                        category: "",
                        tag: ""
                    });
                    setImgFile(null);
                    setImgPreview(null);
                    setShowEditModal(false);
                }}
                style={customModalStyles}
                contentLabel="Edit Research"
            >
                <h2>Edit Research</h2>
                <form onSubmit={handleEditResearch}>
                    {[
                        { label: "Title", name: "title", type: "text" },
                        { label: "Description", name: "description", type: "textarea" },
                        { label: "Type", name: "type", type: "text" },
                        { label: "Categoryl", name: "category", type: "text" },
                        { label: "Tag", name: "tag", type: "text" },
                    ].map(({ label, name, type, required }) => (
                        <div key={name} style={{ marginBottom: "10px" }}>
                            <label
                                style={{
                                    display: "block",
                                    fontWeight: "bold",
                                    marginBottom: "5px",
                                }}
                            >
                                {label}
                            </label>
                            {type === "textarea" ? (
                                <textarea
                                    name={name}
                                    value={formData[name]}
                                    onChange={handleChange}
                                    required={required}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        height: "100px", // Adjust height as needed
                                    }}
                                />
                            ) : (
                                <input
                                    type={type}
                                    name={name}
                                    value={formData[name]}
                                    onChange={handleChange}
                                    required={required}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            )}
                        </div>
                    ))}
                    <div style={{ marginBottom: "10px" }}>
                        <label
                            style={{
                                display: "block",
                                fontWeight: "bold",
                                marginBottom: "5px",
                            }}
                        >
                            Upload
                        </label>
                        <input
                            type="file"
                            onChange={handleFileChange}
                            style={{
                                width: "100%",
                                padding: "8px",
                                fontSize: "14px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                            }}
                        />
                    </div>
                    {imgPreview && (
                        <img
                            src={imgPreview}
                            alt="Preview"
                            style={{ width: "30%", height: "auto", marginBottom: "15px" }}
                        />
                    )}
                    <button
                        type="submit"
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "#4CAF50",
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            marginTop: "10px",
                        }}
                    >
                        {buttonLoading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            "Update"
                        )}
                    </button>
                </form>
            </Modal>
        </div>
    );
}